import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_438: DocMigration = {
  maxSchemaVersion: "0.0.438",
  description: "Add missing view template override method",
  apply(json: any) {
    for (const vtoId in json.viewTemplateOverrides) {
      const vto = json.viewTemplateOverrides[vtoId];

      if (vto.selectionMethod === undefined) {
        vto.selectionMethod = "BY_TAG";
      }
    }

    return json;
  },
};

export default migration_0_0_438;
